import { Dialog, DialogContent } from "@mui/material";
import React, { useState } from "react";
import completeIcon from "../images/completion-quiz.png";
export default function CompletionPopUp() {
  const [open, setOpen] = useState(true);

  return (
    <div>
      {open ? (
        <>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            style={{
              height: "100vh",
              overflowY: "auto", // scrolling still works
              msOverflowStyle: "none", // IE/Edge
              scrollbarWidth: "none", // Firefox
              //   padding: "30px",
              //   width: "600px",
            }}
            className="hide-scrollbar"
            // maxWidth="md" // sm | md | lg
          >
            {/* <img
              width="30"
              height="30"
              src="https://img.icons8.com/ios/50/delete-sign--v1.png"
              alt="delete-sign--v1"
              style={{
                float: "right",
                cursor: "pointer",
                padding: "10px",
              }}
              onClick={() => {
                setOpen(false);
              }}
            /> */}
            <DialogContent
              style={{
                padding: "30px",
                width: "600px",
                height: "50vh",
                overflowY: "auto",
              }}
            >
              {/* Your full component goes here */}
              <img
                src={completeIcon}
                alt="no"
                style={{
                  width: "350px",
                  height: "250px",
                  marginLeft: "16%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
              <h4
                style={{
                  textAlign: "center",
                  marginTop: "2%",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Thank you for participating for the quiz!
              </h4>
            </DialogContent>
          </Dialog>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
